/**
 * Binds Tailwind Typography's `prose` color variables to the app theme tokens.
 *
 * Tailwind Typography injects its own `--tw-prose-*` variables defaulting to the
 * hardcoded slate palette (a blue-tinted gray), independent of the app's theme.
 * Used bare in dark mode, that dark slate renders as dim, bluish, low-contrast text.
 *
 * Apply this class alongside `prose` on any prose surface so element colors follow
 * the theme's foreground / primary / muted-foreground / border tokens. Because the
 * tokens themselves flip per mode, this works in both light and dark with a single
 * declaration — no `dark:prose-invert` needed.
 *
 * Uses the Tailwind `@theme` color variables (`--color-*`) rather than the raw
 * tokens, since those resolve to a valid color under both token conventions in this
 * repo (full `hsl(...)` values in `@ordo/ui/theme`, raw HSL channels in app globals).
 */
export const proseThemeClass = [
  '[--tw-prose-body:var(--color-foreground)]',
  '[--tw-prose-headings:var(--color-foreground)]',
  '[--tw-prose-bold:var(--color-foreground)]',
  '[--tw-prose-quotes:var(--color-foreground)]',
  '[--tw-prose-code:var(--color-foreground)]',
  '[--tw-prose-links:var(--color-primary)]',
  '[--tw-prose-bullets:var(--color-muted-foreground)]',
  '[--tw-prose-counters:var(--color-muted-foreground)]',
  '[--tw-prose-captions:var(--color-muted-foreground)]',
  '[--tw-prose-quote-borders:var(--color-border)]',
  '[--tw-prose-hr:var(--color-border)]',
].join(' ')
